import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { EditarProspectoComponent } from "./editar-prospecto/editar-prospecto.component";
import { EditarProspectoDialog } from "./editar-prospecto/editar-prospecto-dialog/editar-prospecto-dialog.component";
import { EntidadModule } from "../entidad/entidad.module";
import { DetalleProspectoComponent } from "./detalle-prospecto/detalle-prospecto.component";
import { RouterModule } from "@angular/router";
import { VerProspectosComponent } from "./ver-prospectos/ver-prospectos.component";
import { IncidenciaModule } from "../incidencias/incidencia.module";
import { CotizacionModule } from "../cotizaciones/cotizacion.module";
import { TipoIncidenciaService } from "../../providers/tipo-incidencia.service";
import { DireccionService } from "../../providers/direccion.service";
import { CrearProspectoComponent } from "./crear-prospecto/crear-prospecto.component";
import { EsClienteComponent } from "./es-cliente/es-cliente.component";
import { EsClienteDialog } from "./es-cliente/es-cliente-dialog/es-cliente-dialog.component";
import { EntidadResponsableModule } from "../entidad/entidad-responsables/entidad-responsable.module";
import { EliminarProspectoComponent } from "./eliminar-prospecto/eliminar-prospecto.component";
import { EliminarProspectoDialog } from "./eliminar-prospecto/eliminar-prospecto-dialog/eliminar-prospecto-dialog.component";
import { CrearProspectoDialog } from "./crear-prospecto/crear-prospecto-dialog/crear-prospecto-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        PipesModule,
        EntidadModule,
        IncidenciaModule,
        CotizacionModule,
        EntidadResponsableModule,
    ],
    declarations: [
        CrearProspectoComponent,
        CrearProspectoDialog,
        EditarProspectoComponent,
        EditarProspectoDialog,
        EsClienteComponent,
        EsClienteDialog,
        DetalleProspectoComponent,
        EditarProspectoComponent,
        EditarProspectoDialog,
        VerProspectosComponent,
        EliminarProspectoComponent,
        EliminarProspectoDialog,
    ],
    entryComponents: [
        CrearProspectoDialog,
        EditarProspectoDialog,
        EsClienteDialog,
        EditarProspectoDialog,
        EliminarProspectoDialog,
    ],
    exports: [
        CrearProspectoComponent,
        EditarProspectoComponent,
        EsClienteComponent,
        DetalleProspectoComponent,
        EditarProspectoComponent,
        VerProspectosComponent,
        EliminarProspectoComponent,
        CotizacionModule,
    ],
    providers: [
        TipoIncidenciaService,
        DireccionService,
    ]
})
export class ProspectoModule { }